import styled from 'styled-components'

import { MAX_MOBILE_WIDTH } from 'src/Styled/variables'

export const ChangeEmailFormContainer = styled.form`
  width: 100%;
  max-width: 400px;
  display: flex;
  flex-direction: column;
  margin-top: 40px;
  gap: 24px;
  @media (min-width: ${MAX_MOBILE_WIDTH}) {
    margin-top: 24px;
  }
`
